import HourTickFormatter from './component';

export default HourTickFormatter;
